import type { HomepageSettings } from '../lib/types';
import { resolveMediaUrl } from '../lib/media-url';

export function HomepageHeroMedia({ settings }: { settings: HomepageSettings }) {
  const mediaUrl = resolveMediaUrl(settings.heroMediaUrl);
  const posterUrl = resolveMediaUrl(settings.heroPosterUrl);

  if (settings.heroMediaType === 'VIDEO' && mediaUrl) {
    return (
      <div className="hero-figure hero-figure-media">
        <video
          src={mediaUrl}
          poster={posterUrl}
          autoPlay
          muted
          loop
          playsInline
          aria-label="Video nền trang chủ"
        />
        {settings.heroArtLabel && <span className="hero-art-label">{settings.heroArtLabel}</span>}
      </div>
    );
  }

  if (settings.heroMediaType === 'IMAGE' && mediaUrl) {
    return (
      <div className="hero-figure hero-figure-media">
        <img src={mediaUrl} alt="Ảnh giới thiệu trang chủ" />
        {settings.heroArtLabel && <span className="hero-art-label">{settings.heroArtLabel}</span>}
      </div>
    );
  }

  return (
    <div className="hero-figure" aria-hidden="true">
      <div className="hero-orbit hero-orbit-one" />
      <div className="hero-orbit hero-orbit-two" />
      <span className="hero-monogram">AI</span>
      {settings.heroArtLabel && <span className="hero-art-label">{settings.heroArtLabel}</span>}
    </div>
  );
}
